import PropTypes from "prop-types"
import React from "react"

import { StyledLabel } from "./styled"

/**
 * Proxy Component implmenting a styled `<label/>`-Component, used by CheckBox, RadioButtonGroup, and Input-Component
 */
const Label = ({ className = "tsr-label", error, ...props }) => <StyledLabel className={className} {...props} />

Label.propTypes = {
  /**
   * passed down css-default-class for styling purpose
   */

  className: PropTypes.string,
  /**
   * If true astherisk is added
   */
  required: PropTypes.bool,
  /**
   * disable Label
   */

  disabled: PropTypes.bool,
  /**
   * render label as inline block
   */

  $inline: PropTypes.bool,
  /**
   * error state for styling (filtered out from DOM)
   */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

export { Label }
